module.exports = __webpack_public_path__ + "media/images/Closecircle-03f3fb0c.png";